import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const prefectContract = c.router({
  triggerIntegration: {
    method: "POST",
    path: "/prefect/trigger-integration",
    body: z.object({
      importId: z.string(),
    }),
    summary: "Trigger Prefect integration flow",
    responses: {
      200: z.object({ success: z.boolean() }),
    },
  },
  getFlowRun: {
    method: "GET",
    path: "/prefect/flow-runs/:id",
    summary: "Get a specific Prefect flow run",
    responses: {
      200: z.object({ success: z.boolean(), data: z.unknown() }),
    },
  },
});
